const subscribeDestination = '/user/request-response';
const errorDestination = '/user/error';

export default function ResponseBus(client) {
    const handlers = (this.handlers = {});
    this.multiHandlers = [];

    client.onReceive(
        function onReceive(message) {
            const headers = message.headers;
            const id = headers.id;
            const key = headers.key;
            const handler = handlers[id] || this.findMultiHandler(id, key);
            if (handler) {
                const callback = handler.callback;
                if (headers.destination === subscribeDestination) {
                    callback(null, JSON.parse(message.body), headers);
                    // These two repeating if blocks could be moved to after the if else block
                    // when the issue with double fetch has been fixed (PLAT-182)
                    if (!handler.keep) {
                        this.removeHandler(id);
                    }
                } else if (headers.destination === errorDestination) {
                    const err = new Error(message.body);
                    err.headers = headers;
                    callback(err);
                    if (!handler.keep) {
                        this.removeHandler(id);
                    }
                }
            }
        }.bind(this)
    );

    client.onConnect(function onConnect(err) {
        if (!err) {
            // id and destination has the same value because we only
            // need one subscription active per destination
            client.subscribe(subscribeDestination, subscribeDestination, undefined, undefined, undefined, undefined, true);
            client.subscribe(errorDestination, errorDestination, undefined, undefined, undefined, undefined, true);
        }
    });
}

ResponseBus.prototype.addHandler = function (id, callback, keep) {
    this.handlers[id] = { callback: callback, keep: keep };
};

ResponseBus.prototype.removeHandler = function (id) {
    this.handlers[id] = undefined;
};

ResponseBus.prototype.addMultiHandler = function (id, callback, keep, key) {
    const objectToPush = { id, callback: callback, keep: keep, key };
    const handler = this.findMultiHandler(id, key);
    if (handler) {
        const indexExisting = this.multiHandlers.indexOf(handler);
        this.multiHandlers[indexExisting] = objectToPush;
    } else {
        this.multiHandlers.push(objectToPush);
    }
};

ResponseBus.prototype.removeMultiHandler = function (id, key) {
    const handler = this.findMultiHandler(id, key);
    const indexToRemove = this.multiHandlers.indexOf(handler);
    this.multiHandlers.splice(indexToRemove, 1);
};

ResponseBus.prototype.findMultiHandler = function (id, key) {
    return this.multiHandlers.find(handler => handler.id === id && handler.key === key);
};
